import React, { useState } from "react";
import { useLocalStorage } from "../auth/useLocalStorage";
import { IProductionPlanSelection } from "../common/interfaces";
import { ProductionDailyPlan } from "./productionDailyPlan";
import { ProductionsExecute } from "./productionsExecute";

interface ProductionsProps {
  handleCancel: () => void;
}

/**
 * Producciones en dos pasos: abre en el plan del día (qué conviene producir y
 * cuánto) y de ahí se pasa a ejecutar con las cantidades ya precargadas.
 *
 * Conserva la firma `{ handleCancel }` que espera utilsButtons, así que la
 * entrada desde Utilidades y el deep-link `defaultOpen: "productions"` siguen
 * funcionando igual.
 */
export const Productions = (props: ProductionsProps) => {
  const { handleCancel } = props;
  const [user] = useLocalStorage("user", null);

  const [step, setStep] = useState<"plan" | "execute">("plan");
  const [selection, setSelection] = useState<IProductionPlanSelection[]>([]);

  if (step === "plan") {
    return (
      <ProductionDailyPlan
        warehouseId={user?.warehouse_id}
        handleCancel={handleCancel}
        onContinue={(sel) => {
          setSelection(sel);
          setStep("execute");
        }}
        onSkipToExecute={() => {
          setSelection([]);
          setStep("execute");
        }}
        restoreSelection={selection}
      />
    );
  }

  return (
    <ProductionsExecute
      handleCancel={handleCancel}
      onBack={() => setStep("plan")}
      initialSelection={selection}
    />
  );
};
